import { isNative } from '../platform/native';
import { notificationsAllowed } from '../platform/notifications';
import { friendAlertsOn, setFriendAlerts } from './push';
import { saves } from './records';
import { syncDailyReminders } from './reminders';

/**
 * The Daily reminder and friend alerts start on, but the phone asks the player first: once, on the
 * menu after their first lawn (one system prompt covers both). A no turns both off; Settings can
 * turn them on again later.
 */
export async function askForNotificationsOnce(): Promise<void> {
  if (!isNative()) return;
  const save = saves().save;
  if ((save.tipsSeen ?? []).includes('notifications') || save.stats.lawnsMowed < 1) return;
  saves().update((s) => (s.tipsSeen = [...(s.tipsSeen ?? []), 'notifications']));
  // Both already off (a player who chose that before): nothing to ask for.
  if (!save.settings.dailyReminder && !save.settings.friendAlerts) return;
  const allowed = await notificationsAllowed(true);
  if (!allowed) {
    saves().update((s) => {
      s.settings.dailyReminder = false;
      s.settings.friendAlerts = false;
    });
  }
  syncDailyReminders();
  if (allowed && friendAlertsOn()) void setFriendAlerts(true);
}
